import Card from 'react-bootstrap/Card';

function Forum({ forum }) {
    const { forumName, forumId, topics, meta: { count = 0 } = {} } = forum;
    function renderTopic(topic) {
        const { postSubject, topicId } = topic;
        return (
            <li key={topicId}>
                <a href={`/show-topic/${topicId}`}>
                    {postSubject}
                </a>
            </li>
        );
    }
    return (
        <Card>
            <Card.Header>
                <span>{forumName}</span>
                <span>Total Posts: {count}</span>
            </Card.Header>
            <Card.Body>
                <Card.Title>
                    Most recent topics:
                </Card.Title>
                <ul>
                    {
                        topics.map(renderTopic)
                    }
                </ul>
                {
                    count > topics.length ? 
                        <div className='all-forum-topics'>
                           <a href={`/list-topics/${forumId}`}>
                               Show all forum topics
                            </a>
                        </div> 
                    : 
                        <></>
                }
            </Card.Body>
        </Card>
    )

}

export default Forum;